import { AIR_TECHNIQUES_REFS } from './constants'

const isAirTechniquesRef = (ref: string): boolean => {
  return AIR_TECHNIQUES_REFS.includes(ref)
}

export { isAirTechniquesRef }
